import script from "./RuleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleIndex.vue?vue&type=script&setup=true&lang=js"

import "./RuleIndex.vue?vue&type=style&index=0&id=75313538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75313538"]])

export default __exports__